import React, {Component} from 'react';
import {PortfolioContext} from '../contexts/recentsWorks';
import OtherProjects from "../components/projects/OtherProjects";
// import Grid from '@material-ui/core/Grid';
import OffersCard from '../components/OffersCard';
// import Loading from './../components/Loading';
import FeaturedProjects from '../components/projects/FeaturedProjects';
import {Helmet} from "react-helmet";

export default class RecentWorks extends Component {
    static contextType = PortfolioContext;
    
    render() {
        let {forSaleCoverProject: offerCard,loading} = this.context;
        offerCard = offerCard.map((item, index) => {
            return <OffersCard
                key={index}
                name={item.name}
                category={item.category}
                description={item.description}
                developed={item.developed}
                developerName={item.developerName}
                featured={item.featured}
                forSale={item.forSale}
                images={item.images}
                price={item.price}
                priceAfterSale={item.priceAfterSale}
                projectSkills={item.projectSkills}
                saleCover={item.saleCover}
                salePercent={item.salePercent}
                slug={item.slug}
                uiDesignerName={item.uiDesignerName}/>
        })

        return ( <>
           <Helmet>
                <meta charSet="utf-8" />
                <title>Mostafa Abdelazeem - Recent works</title>
                <meta name="description" content="I'm a senior Front-End Developer with +5 years of experience and Extensive Experience in the Design, Development, and maintenance of the website to fix responsive and other issues, I have Extensive Skills in HTML5, CSS3, Javascript,3D Animation using Three.js, and 2d Animation with GSAP, and Responsive"></meta>
                <meta name="keywords" content=""></meta>
                <meta name="robots" content="index, follow"/>
                <meta property="og:type" content="website" />
                <meta property="og:title" content="Mostafa Abdelazeem" />
                <meta property="og:description" content="I'm a senior Front-End Developer with +5 years of experience and Extensive Experience in the Design, Development, and maintenance of the website to fix responsive and other issues, I have Extensive Skills in HTML5, CSS3, Javascript,3D Animation using Three.js, and 2d Animation with GSAP, and Responsive" />
                <meta property="og:image" content="http://moabdo.netlify.app/static/media/hero.5c32137d.jpg" />
                <meta property="og:url" content="https://moabdo.netlify.app/" />
                <meta property="og:site_name" content="Mostafa Abdelazeem - Portfolio" />
            </Helmet>
         {/* <div className="recentWorks text-center">
            <h3>Offers is Here</h3>
            <div className="container">
                <div className="offers-container">
                    {loading
                        ? <Loading/>
                        : <Grid
                            container
                            spacing={3}
                            style={{
                            marginTop: '10vh'
                        }}>
                            <Grid item xs={12} md={6} className='text-left'>
                                {offerCard}
                            </Grid>
                            <Grid item xs={12} md={6} className='text-left'>
                                {offerCard}
                            </Grid>
                        </Grid>
}
                </div>
            </div>
         
        </div> */}

            <div className="recent-work text-center container"
             style={{
                marginTop: '50px',
                paddingTop: '3rem'
            }}>
                <h1>Recent Works</h1>
                <div className="feature-projects text-left">
                    <FeaturedProjects/>
                </div>
                <div className="recent-work-container">
                    <OtherProjects/> 
                </div>
            </div>

            </>
        )
    }
}